import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import {NgbButtonsModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';

import { CoreCommonModule } from '@core/common.module';

import { BreadcrumbModule } from 'app/layout/components/content-header/breadcrumb/breadcrumb.module';
import { ContentHeaderComponent } from 'app/layout/components/content-header/content-header.component';
import {Ng2FlatpickrModule} from "ng2-flatpickr";

@NgModule({
  declarations: [ContentHeaderComponent],
  imports: [CommonModule, RouterModule, CoreCommonModule, BreadcrumbModule, Ng2FlatpickrModule, NgbButtonsModule],
  exports: [ContentHeaderComponent]
})
export class ContentHeaderModule {}

